import { Button, Form, Input, Radio, RadioChangeEvent } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../modules";
import { getSelectedCenterAsync } from "../../modules/selectedCenter";
import { useEffect, useRef, useState } from "react";
import CheckInWellnessLecture from "./wellnessLecture";
import CheckInProgram from "./program";

const CheckIn = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const update = getSelectedCenterAsync;
    const [wellnessType, setWellnessType] = useState<"wellnessClass" | "wellnessProgram">("wellnessClass");
    const [targetMobile, setTargetMobile] = useState<string>('');
    const [isOnClickRequestBtn, setIsOnClickRequestBtn] = useState<boolean>(false);
    const [programBookingId, setProgramBookingId] = useState<number>();
    const bufferRef = useRef('');
    const isScanning = useRef(false);
    const timeout = useRef<NodeJS.Timeout | null>(null);
    const { companyId, yogaCenterId } = useSelector((state: RootState) => state.selectedCenter);
    const mobileKeyDown = (event: KeyboardEvent) => {
        if (event.key === "#") {
            if (isScanning.current) {
                setProgramBookingId(Number(bufferRef.current))
                isScanning.current = false;
                bufferRef.current = '';
            } else {
                isScanning.current = true;
                bufferRef.current = '';
            }
            return;
        }

        if (isScanning.current) {
            if (timeout.current) clearTimeout(timeout.current);
            if (!isNaN(Number(event.key))) {
                bufferRef.current += event.key;
            }
            timeout.current = setTimeout(() => {
                isScanning.current = false;
                bufferRef.current = '';
            }, 100);
        } else {
            if (event.key === " ") {
                return
            }
            if (event.key === "Backspace") {
                setTargetMobile((curr) => curr.length > 0 ? curr.slice(0, -1) : curr);
            } else if (!isNaN(Number(event.key))) {
                setTargetMobile((curr) => curr.length < 11 ? curr + event.key : curr);
            }
        }
    };
    const onChangeYogaCenterId = (e: RadioChangeEvent) => {
        dispatch(update({ companyId: companyId, yogaCenterId: e.target.value }))
        localStorage.setItem("hotelyoga_yogaCenterId", e.target.value.toString());
    }

    useEffect(() => {
        if (companyId) return
        dispatch(update({ companyId: 1, yogaCenterId: yogaCenterId }))
        localStorage.setItem("hotelyoga_companyId", '1')
    }, [companyId])

    useEffect(() => {
        document.addEventListener('keydown', mobileKeyDown)
        return () => { document.removeEventListener('keydown', mobileKeyDown); }
    }, [])

    return <>
        <Form
            key={yogaCenterId}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
            labelAlign='left'
            colon={false}
            style={{ paddingBottom: '16px' }}
        >
            <Form.Item label="구분">
                <Radio.Group value={wellnessType} onChange={q => { setTargetMobile(''); setWellnessType(q.target.value) }}>
                    <Radio value="wellnessClass">클래스</Radio>
                    <Radio value="wellnessProgram">프로그램</Radio>
                </Radio.Group>
            </Form.Item>

            {wellnessType === 'wellnessClass' && <Form.Item label="센터 선택">
                <Radio.Group value={yogaCenterId} onChange={onChangeYogaCenterId}>
                    <Radio value={2}>도산</Radio>
                    <Radio value={3}>선릉</Radio>
                </Radio.Group>
            </Form.Item>}
            <Form.Item label="휴대폰번호">
                <div style={{ display: 'flex', gap: '24px' }}>
                    <Input style={{ maxWidth: '441px' }} value={targetMobile} placeholder="하이픈(-)제외하고 입력" />
                    <Button color="primary" variant="outlined" onClick={() => setIsOnClickRequestBtn(true)}>{wellnessType === 'wellnessClass' ? '검색' : '적용'}</Button>
                    {wellnessType === 'wellnessClass' && <Button onClick={() => navigate(`/check-in/screen/${companyId}/${yogaCenterId}`)}>회원용 테블릿 화면</Button>}
                </div>
            </Form.Item>
        </Form>
        {wellnessType === 'wellnessClass' && <CheckInWellnessLecture isInit={wellnessType === 'wellnessClass'} targetMobile={targetMobile} setTargetMobile={setTargetMobile} isOnClickRequestBtn={isOnClickRequestBtn} setIsOnClickRequestBtn={setIsOnClickRequestBtn} />}
        {wellnessType === 'wellnessProgram' && <CheckInProgram targetMobile={targetMobile} isOnClickRequestBtn={isOnClickRequestBtn} setIsOnClickRequestBtn={setIsOnClickRequestBtn} programBookingId={programBookingId} setProgramBookingId={setProgramBookingId} />}
    </>

}
export default CheckIn;